import CreateLeadPage from './CreateLeadPage';

export default CreateLeadPage;
